module.exports = __webpack_public_path__ + "be4d2aa6abcddbd5ef3396d86e99be66.png";